import { render, staticRenderFns } from "./IsSafe.vue?vue&type=template&id=1f39fb56"
import script from "./IsSafe.vue?vue&type=script&lang=ts"
export * from "./IsSafe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports